import React from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import OptionSection from 'src/js/modules/common/components/option-section';

const { Box, Stack } = designSystem;

function Section({ children, title, popoverProps = null }) {
  return (
    <Box
      paddingTop="spacing-xs"
      paddingBottom="spacing-s"
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <Stack gap="spacing-2-xs">
        <OptionSection title={title} popoverProps={popoverProps} bold />
        {children}
      </Stack>
    </Box>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  popoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
};

export default Section;
